<template class="blue">
        <v-card flat tile dark class="mb-4 blue">
          <v-toolbar flat dark class="blue"  >
            <v-toolbar-title class="mx-auto">{{title}} </v-toolbar-title>
          </v-toolbar>
          <v-container fluid grid-list-lg >
            <v-layout row wrap>       
              <v-flex xs12>
                <div class="text-xs-center" id="valButtons">
                  <div class="headline"></div>
                  <v-flex xs10 text-xs-center mx-auto>
                    <div v-for="items in activityTypes" :key="items.text" >
                      <div v-if="items.actId==postActId">
                        <v-btn block round flat color="white" :to="'/val'">{{items.text}}</v-btn>
                      </div>
                    </div>
                    <div v-for="item in activityIntensityTypes"  :key="item.index" >
                      <div v-if="item.actId==postActId && item.value==postIntensity ">
                        <v-btn block  round flat color="white"  :to="'/val/'+item.actId">{{item.name}}</v-btn>
                      </div>
                    </div>
                    <div v-for="itemd in actDurations"  :key="itemd.key">
                        <div v-if="itemd==postDuration">
                          <v-btn block round flat color="white"  :to="'/val/'+postActId+'/'+postIntensity">{{formatDuration(itemd)}}</v-btn>
                        </div>
                    </div>                        
                  </v-flex>
                  <v-flex xs10 text-xs-center mx-auto>
                     <div class="display-3">+{{activitySubmissionValue}}</div>
                     <div class="subheading">Voice Activity Points</div>
                   </v-flex> 
                  <v-flex xs10 text-xs-center mx-auto>  
                      <div class="subheading mb-2 mt-4">Add Notes</div>
                        <v-text-field
                                v-model="inputNotes"
                                label="Add an optional note"
                                textarea round
                                  class="white inputNotes" 
                        ></v-text-field>
                  </v-flex>
                  <v-flex xs10 text-xs-center mx-auto >  
                    <v-btn block large color="green" class="mt-4" v-on:click.native="addVocalActivity()">Save This Activity</v-btn>
                  </v-flex>
                </div>
              </v-flex>            
            </v-layout>
          </v-container>
        </v-card> 
</template>
<style>
div.inputNotes .input-group__input textarea{ color: #000;}
</style>
<script>
import AppConst from '../AppConst.js'
import CreateActivityMutation from '../mutations/CreateActivityMutation';

var actObj=AppConst.activityTypesDefaults;
var actIntensityObj=AppConst.activityIntensityTypesDefaults;
var actDurationObj=AppConst.activityDurationDefaults;
     
//calculate value
var activityTypeText='';
var activityIntensityText='';
var inputNotes='';

function validateCal(actIntensityObj, that){

        var paths=window.location.pathname.split("/")
        var postActId=parseInt(paths[2]);
        var postIntensity=parseInt(paths[3]);
        var postDuration=parseInt(paths[4]);
        var activitySubmissionValueCal=0;

        // set postActIdText
        actObj.forEach(function(item){
          if(item.actId==postActId) {
              activityTypeText=item.text;
          }
        });

        actIntensityObj.forEach(function(item){
            if( (item.actId==postActId) && (item.value==postIntensity) ){
              if(postDuration>0){
                activityIntensityText=item.name;
                activitySubmissionValueCal=parseInt(item.value*(postDuration/60));
              }

            }

        });

        //Check for valid data
        if( activitySubmissionValueCal==0 || isNaN(activitySubmissionValueCal)){
          alert('Invalid data submitted, please resubmit the activity');
          that.$router.push({path:'/val'});
        }
        localStorage.vocalActivityTotal = activitySubmissionValueCal;
        that.activitySubmissionValue = activitySubmissionValueCal;
        return activitySubmissionValueCal;

}



export default {
  data () {
    return {
      title: 'Save Activity',
      activityTypes: actObj,
      activityIntensityTypes: actIntensityObj,
      actDurations: actDurationObj,
      activitySubmissionValue: validateCal(actIntensityObj, this),
      CreateActivityMutation: CreateActivityMutation,
      inputNotes: inputNotes,
      activityIntensityText: activityIntensityText,
      activityTypeText: activityTypeText,
    }
  },
  methods: {
    addVocalActivity: function () {
      var that=this;
      if( this.activitySubmissionValue==0 || isNaN(this.activitySubmissionValue)){
        this.$router.push({path:'/val'});
      }

      //gather inputs
      var avaInput = {
              id: localStorage.subID+'--'+( new Date().getTime() ),
              username:  localStorage.subID,  
              actDate: localStorage.currentDate,
              activityType: activityTypeText,
              timestamp: ( new Date().getTime() ),
              value: this.activitySubmissionValue,
              intensity: activityIntensityText,
              notes: this.inputNotes,    
      } 
      //check if notes is an empty string, if so remove
      if(avaInput.notes==''){ delete avaInput.notes; }

      //add to dynamodb
      this.$apollo.mutate({
          variables: {
              input: avaInput
          },
          mutation: CreateActivityMutation
      }).then(function() {
          that.$router.push({path:'/home'});
      }).catch(error => console.error(error));
                
      //what i tried to add

      //redirect back to home

    },
    formatDuration(mins){
        mins=parseInt(mins);
        if(mins<60){ return ""+mins+" mins"; }
        if((mins%60)!=0){
           return ""+Math.floor((mins/60))+" hrs "+(mins%60)+" mins"; 
        }
        else { 
           return ""+Math.floor((mins/60))+" hrs "; 
        }
    }   
  }, 
  props: [ 
    'postActId',
    'postIntensity',   
    'postDuration',
  ]
  
}
</script>









// WEBPACK FOOTER //
// src/components/val/ValNotes.vue